export default {"src":"/_next/static/media/TeethGrinding.8d916530.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};